<!-- Cuando redeemCodes es TRUE -->
<div *ngIf="item.redeemCodes === true" 
     [ngClass]="{'benefit-box': true, 'benefit-page': isMobileOrBenefitPage}"
     [routerLink]="isMobileOrBenefitPage ? '/beneficios-y-descuentos/' + categoryNameUrl(item.category?.name) + '/' + item.name : null">

  <div *ngIf="isMobileOrBenefitPage">
    <div class="benefit-image">
      <img class="partner-img" [src]="item.partner.logo" alt="partner logo">
      <div class="benefit-type">
        <img [src]="getBenefitTypeImage(item.benefit_type)" alt="">
        <span>{{ transformText(item.benefit_type) }}</span>
      </div>
    </div>
  </div>

  <div *ngIf="!isMobileOrBenefitPage">
    <img class="partner-img" [src]="item.partner.logo" alt="partner logo">
  </div>

  <div class="benefit-description">
    <div class="benefit-detail">
      <span>{{ transformText(item.category?.name) }}</span>
      <div [ngClass]="{'benefit-page-text': isMobileOrBenefitPage}">
        <h3 *ngIf="item.typete === '$' && item.discount !== 'null'">{{ item.typete }}{{ item.discount }}</h3>
        <h3 *ngIf="item.typete === '%' && item.discount !== 'null'">{{ item.discount }}{{ item.typete }}</h3>
        <h3 *ngIf="item.typete !== '$' && item.typete !== '%' && item.discount !== 'null'">{{ item.discount }}{{ item.typete }}</h3>
        <p>{{ item.benefit_discount !== 'null' ? transformText(item.benefit_discount) : '' }}</p>
      </div>
      <span class="refund-test" *ngIf="item.name === 'prex-10-de-descuento'">
        +10% Reintegro <img src="../../../assets/icon/icon-prex.svg" alt="">
      </span>
    </div>

    <div class="benefit-use">
      <div *ngIf="!isMobileOrBenefitPage" class="benefit-type">
        <img [src]="getBenefitTypeImage(item.benefit_type)" alt="">
        <span>{{ transformText(item.benefit_type) }}</span>
      </div>
      <div class="benefit-days">
        <span *ngFor="let day of weekDays" [ngClass]="{ 'active-day': isActiveDay(day.value), 'inactive-day': !isActiveDay(day.value) }">
          {{ day.label }}
        </span>
      </div>
    </div>

    <button *ngIf="!isMobileOrBenefitPage" (click)="navigate(item.category?.name, item.name)">Ver más</button>
  </div>
</div> 


  
<!-- Cuando redeemCodes es FALSE -->
<div *ngIf="item.redeemCodes === false" 
     class="container-no-redeemCodes"
     [ngClass]="{'benefit-page': isMobileOrBenefitPage}"
     [routerLink]="isMobileOrBenefitPage ? '/beneficios-y-descuentos/' + categoryNameUrl(item.category?.name) + '/' + item.name : null">

  <div *ngIf="isMobileOrBenefitPage" class="container-img-no-redeemCodes">
      <img class="partner-img" [src]="item.partner.logo" alt="partner logo">
  </div>

  <div *ngIf="!isMobileOrBenefitPage" class="container-img-no-redeemCodes-2">
    <img class="img-thumbnail-no-redeemCodes" [src]="item.imgThumbnail" alt="partner logo">
  </div>

  <div class="benefit-section" [ngStyle]="{ padding: getBenefitCategoryName(item.name) === 'Todos los productos' ? '0' : '8px 16px 8px 16px'}" [ngClass]="{ 'both-types': showBothTypesClass }">
    <img
      [src]="getTypeImage(getBenefitCategoryName(item.name))"
      *ngIf="getTypeImage(getBenefitCategoryName(item.name)) && getBenefitCategoryName(item.name) !== 'Todos los productos'"
      alt=""
    />
    <span>{{ getBenefitCategoryName(item.name) }}</span>
  </div>

  <div class="benefit-type-discount">
    <div class="benefit-detail">
      <div [ngClass]="{'benefit-page-text': isMobileOrBenefitPage}">
        <h3 *ngIf="item.typete === '$' && item.discount !== 'null'" class="benefit-typete">{{ item.typete }}{{ item.discount }}</h3>
        <h3 *ngIf="item.typete === '%' && item.discount !== 'null'" class="benefit-typete">{{ item.discount }}{{ item.typete }}</h3>
        <h3 *ngIf="item.typete !== '$' && item.typete !== '%' && item.discount !== 'null'" class="benefit-typete">{{ item.discount }}{{ item.typete }}</h3>
        <p class="benefit-icon">
          {{ item.benefit_discount !== 'null' ? transformText(item.benefit_discount) : '' }}
          <span *ngIf="getBenefitIcon(item.name)">con</span>
          <img *ngIf="getBenefitIcon(item.name)" class="icon-benefit" [src]="getBenefitIcon(item.name)" alt="icon benefit">
        </p>
      </div>
      <span class="refund-test" *ngIf="item.name === 'prex-10-de-descuento'">
        +10% Reintegro <img src="../../../assets/icon/icon-prex.svg" alt="">
      </span>
    </div>

    <div class="benefit-use-box">
        <div class="discount-limit">
          <span  *ngIf="getDiscountLimit(item.name) !== undefined">
           {{ getDiscountLimit(item.name) }}
          </span>
        </div>
        <div class="discount-limit-valid">
          <p class="text">Válido</p>
          <span *ngFor="let day of weekDays" [ngClass]="{ 'active-day': isActiveDay(day.value), 'inactive-day': !isActiveDay(day.value) }">
            {{ day.label }}
          </span>
      </div>
    </div>
  </div>
</div> 
